export const FIELD_TYPES = {
    AMOUNT: 'amount',
    ARRAY: 'array',
    BADGE: 'badge',
    BOOLEAN: 'boolean',
    COLOR: 'color',
    COMPONENT: 'component',
    DATE: 'date',
    DATE_NO_TIME: 'dateNoTime',
    DATE_TIME_SHORT: 'dateTimeShort',
    ICON: 'icon',
    IMAGE: 'image',
    LINK: 'link',
    MULTI_ENTITY: 'multiEntity',
    NUMBER: 'number',
    OBJECT: 'object',
    PORT: 'port',
    TEXT: 'text'
};
